import React, { useEffect, useMemo } from 'react';
import Const from 'const.json';
import Card from 'components/Card/Card';
import { useYearFromRedux } from 'utils/utilsLogic';
import ListItemWithIcon from 'components/controls/ListItemWithIcon/ListItemWithIcon';
import { HowComplaintsAreReceivedEnum, MediaQuery } from 'enums/enums';
import ListItemCarousel from 'components/controls/ListItemCarousel/ListItemCarousel';
import { EntityComplaint } from 'types/EntityComplaint';
import useMediaQuery from 'hooks/useMediaQuery';
import { GetComplaintsByHowComplaintsAreReceived } from 'api/apiService';
import useApi from 'hooks/useApi';
import { useAppSelector } from '../../redux/hooks';
import WithApi from 'components/ui/WithApi/WithApi';

const HowComplaintsAreReceived: React.FC = () => {
    const { period } = useAppSelector((state) => state.general);
    const { callApi, data, loading, error } = useApi<EntityComplaint[]>(GetComplaintsByHowComplaintsAreReceived);
    const { comparisonTextToLastYear } = useYearFromRedux();
    const isNotDesktop = useMediaQuery(MediaQuery.NotDesktop);

    const header = Const.howComplaintsAreReceived;

    const logoDictionary = new Map<string, string>([
        [HowComplaintsAreReceivedEnum.Internet, require('assets/images/internet.png')],
        [HowComplaintsAreReceivedEnum.Email, require('assets/images/email.png')],
        [HowComplaintsAreReceivedEnum.Reception, require('assets/images/reception.png')],
        [HowComplaintsAreReceivedEnum.Fax, require('assets/images/fax.png')],
        [HowComplaintsAreReceivedEnum.Phone, require('assets/images/phone.png')],
        [HowComplaintsAreReceivedEnum.Mail, require('assets/images/mail.png')]
    ]);

    useEffect(() => {
        callApi();
        if (data) {
            data.forEach(data => data.logo = logoDictionary.get(data.id))
        }
    }, [period]);

    const complaints = useMemo(() => {
        let complaints = [];
        if (data) {
            data.forEach(data => data.logo = logoDictionary.get(data.id));
            complaints = data.sort((a, b) => {
                const idA = parseInt(a.id, 10);
                const idB = parseInt(b.id, 10);
                if (isNaN(idA) || isNaN(idB)) {
                    throw new Error('Invalid id: id must be a valid number');
                }

                return idA - idB;
            });
        }
        return complaints
    }, [data])
    if (isNotDesktop) {
        return (
            <WithApi data={data} loading={loading} error={error}>
                <ListItemCarousel
                    header={header}
                    subHeader={comparisonTextToLastYear}
                    complaints={complaints}
                />
            </WithApi>

        );
    }
    return (
        <Card
            header={header}
            subHeader={comparisonTextToLastYear}
            components={[
                <WithApi data={data} loading={loading} error={error}>
                    <div className="list-item-with-icon-row">
                        {complaints.map((item: EntityComplaint) => <ListItemWithIcon key={item.id} complaint={item} isDecorationIcon={true}/>)}
                    </div>
                </WithApi>
            ]} />
    );

};

export default HowComplaintsAreReceived;